import toast from 'react-hot-toast';

// Configuration personnalisée pour des notifications plus discrètes
const customToastConfig = {
  duration: 2000,
  style: {
    fontSize: '14px',
    fontWeight: '500',
    maxWidth: '320px',
    borderRadius: '8px',
    padding: '12px 16px',
  }
};

// Notification de succès discrète
export const showSuccess = (message) => {
  toast.success(message, {
    ...customToastConfig,
    duration: 1800,
  });
};

// Notification d'erreur discrète
export const showError = (message) => {
  toast.error(message, {
    ...customToastConfig,
    duration: 3000,
  });
};

// Notification d'information discrète
export const showInfo = (message) => {
  toast(message, {
    ...customToastConfig,
    duration: 2500,
    style: {
      ...customToastConfig.style,
      background: '#3b82f6',
      color: '#fff',
    },
  });
};

// Notification d'avertissement discrète
export const showWarning = (message) => {
  toast(message, {
    ...customToastConfig,
    duration: 3000,
    style: {
      ...customToastConfig.style,
      background: '#f59e0b',
      color: '#fff',
    },
  });
};

// Notification très courte (pour les actions rapides)
export const showQuickSuccess = (message) => {
  toast.success(message, {
    ...customToastConfig,
    duration: 1200,
  });
};

// Notification de chargement
export const showLoading = (message = "Chargement...") => {
  return toast.loading(message, {
    duration: Infinity,
    style: {
      ...customToastConfig.style,
      background: '#3b82f6',
      color: '#fff',
    }
  });
};

// Mettre à jour une notification de chargement
export const updateLoading = (toastId, message, type = 'success') => {
  toast.success(message, {
    id: toastId,
    duration: type === 'success' ? 1500 : 3000,
  });
};

// Notification avec icône personnalisée
export const showCustomNotification = (message, type = 'info', icon = null) => {
  const config = {
    ...customToastConfig,
    icon: icon,
  };
  
  switch (type) {
    case 'success':
      return toast.success(message, config);
    case 'error':
      return toast.error(message, config);
    case 'warning':
      return toast(message, {
        ...config,
        style: {
          ...config.style,
          background: '#f59e0b',
          color: '#fff',
        },
      });
    default:
      return toast(message, {
        ...config,
        style: {
          ...config.style,
          background: '#3b82f6',
          color: '#fff',
        },
      });
  }
}; 